import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";


export default function ProtectedRoutes({ Component }) {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  useEffect(() => {
    if (!token || token === "undefined" || token == null) {
      navigate('/login')
    }
  }, [])

  return (
    <>
      <Component />
    </>
  )
}

